// Small inline glyphs shared across pages. Kept here once the same drawing is
// wanted in more than one place — the per-file inline SVGs elsewhere (the
// Tabler paths in WifiEvents, the metric headings) belong to a single screen.

// Padlock on an option the reader cannot choose: a resolution too fine for its
// range (ModalFilterTemp) or a range the report cannot serve in time
// (DeviceDetail2, useDeviceReport). Inherits colour, so it greys out with the
// text it sits beside.
export const LockIcon = () => (
  <svg
    width="13"
    height="13"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ marginLeft: 5, verticalAlign: "-2px" }}
  >
    <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
    <path d="M7 11V7a5 5 0 0 1 10 0v4" />
  </svg>
);
